import React from 'react';
import { CardGroup, Card, CardBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { DamageClaimsSearch } from '../../views/client/UserMyDamageClaims/DamageClaimsSearch';
import { Spinner } from '../../containers';
import { DamageClaimCard } from '../DamageClaimCard';
import {
  redirectToAdminEditUserSingleClaimPage,
  redirectToAdminEditEmployeeSingleClaimPage,
} from '../../redux/actions/navigationActions';
import { isHOKEmployee } from '../../constants/roles';

export const AdminEditDamagesData = ({ user }) => {
  const isUserEmployee = isHOKEmployee(user);

  return (
    <CardGroup>
      <Card className="hok-card">
        <CardBody>
          <DamageClaimsSearch userId={user.id}>
            {({ data: claims, error, loading }) => {
              if ((!claims && !error) || loading) {
                return <Spinner className="spinner-positioning" />;
              }

              if (claims.length < 1 || error) {
                return (
                  <div className="mx-auto title-text">
                    <p className="hok-text-dark pr-1">
                      <FormattedMessage id="userMyDamageClaims.noDamageClaimsFound" />
                    </p>
                  </div>
                );
              }

              return claims.map(claim => {
                const claimParam = claim.claimNo ? `${claim.claimClass}-${claim.claimNo}` : claim.claimConfirmationCode;
                return (
                  <DamageClaimCard
                    damageClaim={claim}
                    key={claim.claimNo || claim.claimConfirmationCode}
                    redirectAction={() =>
                      isUserEmployee
                        ? redirectToAdminEditEmployeeSingleClaimPage(user.id, claimParam)
                        : redirectToAdminEditUserSingleClaimPage(user.id, claimParam)
                    }
                  />
                );
              });
            }}
          </DamageClaimsSearch>
        </CardBody>
      </Card>
    </CardGroup>
  );
};
